import { FC, useContext, useEffect, useCallback } from "react";
import { observer } from "mobx-react-lite";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../index";
import Logo from "../../assets/mainLogo.svg";
import Background from "../../assets/backgroundLogin.jpg";

const NoAccessPages: FC = () => {
    const { store } = useContext(Context);
    const navigate = useNavigate();
    const location = useLocation();

    const handlePersonActivation = useCallback(async (matchHref: string) => {
        try {
            store.setLinkNewPerson(matchHref);
            const newPerson = await store.getDataLinkPerson(matchHref);
            
            if (!newPerson) return;

            store.setUserWithStatus(newPerson);
            
            await store.logout();

            const navigateRoutes: Record<string, string> = {
                "Приглашен": "/register",
                "Ждет активацию": "/login",
                "Активен": "/login"
            };

            const route = navigateRoutes[newPerson.status];
            if (route) {
                navigate(route);
            }
        } catch (err) {
            console.error("Ошибка активации пользователя:", err);
        }
    }, [store, navigate]);

    useEffect(() => {
        const processNoAccessPath = async () => {
            if (location.pathname.includes("/noAccessPages/")) {
                const matchHref = location.pathname.split("/")[2];
                if (matchHref) {
                    await handlePersonActivation(matchHref);
                }
            }
        };

        processNoAccessPath();
    }, [location.pathname, handlePersonActivation]);

    const handleLogout = useCallback(async () => {
        try {
            await store.logout();
            navigate("/login");
        } catch (err) {
            console.error("Ошибка выхода:", err);
        }
    }, [store, navigate]);

    return (
        <div className="form_main_center">
            <div className="form_container form_container_fullscreen form_container_center">
                <div className="form_logo">
                    <img src={Logo} alt="Логотип компании" />
                </div>
                <h2 className="no-access-header">У вас нет прав на использование системы</h2>
                <div className="form_description">
                    <p className="no-access-text">
                        Для начала работы обратитесь к администратору
                    </p>
                </div>
                <div className="form_flex_row">
                    <button 
                        className="logout-button p_blue p_14 pointer_custom"
                        onClick={handleLogout}
                        type="button"
                    >
                        Выход
                    </button>
                </div>
            </div>
            <img
                src={Background}
                alt="Фон компании"
                className="background_image_fullscreen"
            />
        </div>
    );
};

export default observer(NoAccessPages);